import { Component, Input, Output, EventEmitter, Injectable, signal } from "@angular/core";
import { CommonModule } from "@angular/common";

export interface ModalConfig {
  icon?: "error" | "warning" | "info" | "success" | string;
  title?: string;
  description?: string;
  mainButton?: {
    text: string;
    action?: () => void;
    loading?: boolean;
  };
  secondaryButton?: {
    text: string;
    action?: () => void;
  };
  closeOnBackdrop?: boolean;
}

@Injectable({
  providedIn: "root",
})
export class ModalAlertService {
  private visibleSignal = signal(false);
  private configSignal = signal<ModalConfig>({});

  get visible() {
    return this.visibleSignal();
  }

  get config() {
    return this.configSignal();
  }

  show(config: ModalConfig) {
    this.configSignal.set(config);
    this.visibleSignal.set(true);
  }

  hide() {
    this.visibleSignal.set(false);
  }
}

@Component({
  selector: "app-modal-alert",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./modal-alert.component.html",
  styleUrl: "./modal-alert.component.css",
})
export class ModalAlertComponent {
  @Input() icon?: string;
  @Input() title?: string;
  @Input() description?: string;
  @Input() mainButton?: { text: string; loading?: boolean };
  @Input() secondaryButton?: { text: string };
  @Input() closeOnBackdrop = true;

  @Output() mainAction = new EventEmitter<void>();
  @Output() secondaryAction = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  constructor(public modalService: ModalAlertService) {}

  onMainButtonClick() {
    this.mainAction.emit();
  }

  onSecondaryButtonClick() {
    this.secondaryAction.emit();
  }

  onBackdropClick() {
    if (this.closeOnBackdrop) {
      this.close.emit();
    }
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  closeModal() {
    this.modalService.hide();
    this.close.emit();
  }
}
